import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LiveDetails } from '../live-negotiation/live-details/live-details';
import { ItemDetailsComponent } from '../live-negotiation/item-details/item-details.component';
import { CreateNegotiation } from 'src/app/core-module/negotiation/negotiation-list-module/negotiation-list/create/create-model';
import { vendornegotiationservice } from '../vendornegotiation.service';

@Component({
  selector: 'app-vender-nagotiation-page',
  templateUrl: './vender-nagotiation-page.component.html',
  styleUrls: ['./vender-nagotiation-page.component.scss']
})
export class VenderNagotiationPageComponent {
  date: any;
  vendorId: any;
  total!: any;
  targetDate: any;
  yourQuote: any = [];
  hisData: any = [];
  targetTime: any;
  currentTime: any;
  now: any;
  tr!: any;
  trt!: any;
  difference!: number;
  rowData: any = {
    rfpCode: 'N/A',
    negotiationCode: 'N/A',
    companyBranchName: 'N/A',
    currency_code: 'INR',
    negotiationEndDate: '',
    negotiationEndTime: '',
    negotiationStartTime: ''
  };
  loading: boolean = false;
  isSubmitDisabled: boolean = false;
  months: Array<string> = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  negoDetails: CreateNegotiation = new CreateNegotiation();
  rfpItemType: any;
  negoStartTime: any;
  startTimeFormat!: string;
  negoEndTime: any;
  endTimeFormat!: string;
  dt!: any;
  timer: any;
  dateDifference: any = { days: 0, hours: 0, minutes: 0, seconds: 0 };
  endTime: any;

  @ViewChild('days', { static: true }) days?: ElementRef;
  @ViewChild('hours', { static: true }) hours?: ElementRef;
  @ViewChild('minutes', { static: true }) minutes?: ElementRef;
  @ViewChild('seconds', { static: true }) seconds?: ElementRef;

  liveDetails: LiveDetails = new LiveDetails();

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private vendorNegoService: vendornegotiationservice,
    private toastr: ToastrService,
    private _matDialog: MatDialog,
  ) {
    this.activeRoute.queryParamMap.subscribe((param: any) => {
      console.log('📌 Full Query Params:', param);

      if (param && param.params && param.params.SelectedRFP) {
        this.loading = true;
        const parsedData = JSON.parse(param.params.SelectedRFP);
        this.rowData = { ...this.rowData, ...parsedData };
        console.log('📦 RowData from SelectedRFP:', this.rowData);

        this.dt = this.rowData.negotiationEndDate;
        this.negoStartTime = this.rowData.negotiationStartTime;
        this.endTime = this.rowData.negotiationEndTime;
        this.rfpItemType = this.rowData.bomData?.rfpItemType || this.rowData.rfpItemType;
        this.loading = false;
      }

      if (param && param.params) {
        const negotiationId = param.params.negotiationId || param.params.negotiation_id;
        const rfpId = param.params.rfpId || param.params.rfp_id;
        const vendorId = param.params.vendorId || param.params.vendor_id;
        const companyId = param.params.companyId || param.params.company_id;
        const rfpCategory = param.params.rfpCategory;

        console.log('🔍 Query Params:', {
          negotiationId,
          rfpId,
          vendorId,
          companyId,
          rfpCategory
        });

        if (negotiationId) {
          this.rowData.negotiation_id = negotiationId;
          this.rowData.negotiationId = negotiationId;
          console.log('✅ Set negotiation_id from query params:', negotiationId);
        }

        if (rfpId) {
          this.rowData.rfpId = rfpId;
          this.rowData.rfp_id = rfpId;
          console.log('✅ Set rfpId from query params:', rfpId);
        }

        if (vendorId && !this.vendorId) {
          this.vendorId = vendorId;
          console.log('✅ Set vendorId from query params:', vendorId);
        }
      }
    });
  }

  ngOnInit() {
    console.log('🚀 ngOnInit called');
    console.log('🔍 Current rowData:', this.rowData);
    console.log('🔍 Current vendorId:', this.vendorId);

    if (!this.vendorId) {
      const storedData = localStorage.getItem('user_details') ?? "{}";
      const userDetails = JSON.parse(storedData);
      this.vendorId = userDetails.vendor_id;
      console.log('📦 VendorId from localStorage:', this.vendorId);
    }

    if (!this.rowData?.negotiation_id) {
      console.error('❌ negotiation_id is still undefined!');
      this.toastr.error('Negotiation ID is missing from URL');
      this.loading = false;
      return;
    }

    this.getVendorHistory();
    this.getYourQuote();
  }

  ngAfterViewInit() {
    // Timer start karo agar date/time available hai
    if (this.dt && this.endTime) {
      this.startCountdown();
      this.calculateTotalAmount();
    }
  }

  dateFormate() {
    if (!this.dt) {
      console.warn('⚠️ dt is undefined');
      return;
    }
    this.targetDate = new Date(this.dt);
    this.targetTime = this.targetDate.getTime();
    this.currentTime = `${this.months[this.targetDate.getMonth()]} ${this.targetDate.getDate()}, ${this.targetDate.getFullYear()}`;
  }

  startTimeFormatter() {
    if (!this.rowData?.negotiationStartTime) {
      console.warn('⚠️ negotiationStartTime is undefined');
      return;
    }

    this.negoStartTime = this.rowData.negotiationStartTime;
    let timeParts = this.negoStartTime.toString().split(':');
    let startHour = parseInt(timeParts[0], 10);
    this.startTimeFormat = startHour >= 12 ? 'PM' : 'AM';

    this.negoEndTime = this.rowData.negotiationEndTime;
    if (this.negoEndTime) {
      let timeParts1 = this.negoEndTime.split(':');
      let endHour = parseInt(timeParts1[0], 10);
      this.endTimeFormat = endHour >= 12 ? "PM" : "AM";
    }
  }

  calculateDateDifference(): void {
    if (!this.dt || !this.endTime) {
      console.warn('⚠️ Date or time is undefined');
      return;
    }

    try {
      let negoEndDate = this.dt;
      let negoEndTime = this.endTime;
      let dateParts = negoEndDate.split('-');
      let timeParts = negoEndTime.split(':');
      let year = parseInt(dateParts[0], 10);
      let month = parseInt(dateParts[1], 10) - 1;
      let day = parseInt(dateParts[2], 10);
      let hour = parseInt(timeParts[0], 10);
      let minute = parseInt(timeParts[1], 10);
      let newNegoEndDateTime = new Date(year, month, day, hour, minute);
      const now = new Date();
      const difference = newNegoEndDateTime.getTime() - now.getTime();

      if (difference > 0) {
        this.dateDifference.days = Math.floor(difference / (1000 * 60 * 60 * 24));
        this.dateDifference.hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        this.dateDifference.minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        this.dateDifference.seconds = Math.floor((difference % (1000 * 60)) / 1000);
      } else {
        this.dateDifference.days = 0;
        this.dateDifference.hours = 0;
        this.dateDifference.minutes = 0;
        this.dateDifference.seconds = 0;
        clearInterval(this.timer);
        this.isSubmitDisabled = true;
      }
    } catch (error) {
      console.error('❌ Error calculating date difference:', error);
    }
  }

  private padWithZero(value: number): string {
    return value < 10 ? `0${value}` : value.toString();
  }

  updateCountdown(): void {
    this.calculateDateDifference();
    if (this.days) this.days.nativeElement.innerText = this.dateDifference.days.toString();
    if (this.hours) this.hours.nativeElement.innerText = this.padWithZero(this.dateDifference.hours);
    if (this.minutes) this.minutes.nativeElement.innerText = this.padWithZero(this.dateDifference.minutes);
    if (this.seconds) this.seconds.nativeElement.innerText = this.padWithZero(this.dateDifference.seconds);
  }

  startCountdown(): void {
    // Clear existing timer
    if (this.timer) {
      clearInterval(this.timer);
    }

    this.timer = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  back() {
    this.router.navigate(['/vendor/negotiation/live-negotiation']);
  }

  getVendorHistory() {
    if (!this.rowData?.negotiation_id) {
      console.error('❌ negotiation_id is undefined! Cannot fetch data.');
      this.toastr.error('Negotiation ID is missing');
      this.loading = false;
      return;
    }

    console.log('📤 Calling getVendorHistory with:', {
      negotiation_id: this.rowData.negotiation_id,
      vendorId: this.vendorId
    });

    this.loading = true;
    this.vendorNegoService.getVendorHistory(this.rowData.negotiation_id, this.vendorId)
      .subscribe({
        next: (res: any) => {
          this.loading = false;
          console.log('✅ getVendorHistory Response:', res);

          if (res && res.body) {
            if (res.body.data && res.body.data.length > 0) {
              // ✅ Patch the data into liveDetails
              this.liveDetails.vendorNegotiation = res.body.data;
              this.liveDetails.rfpItemType = this.rfpItemType;
              this.liveDetails.negotiationTotalAmount = res.body.negotiationTotalAmount || 0;

              // ✅ IMPORTANT: rowData mein bhi data set karo for display
              const firstItem = res.body.data[0];
              if (firstItem) {
                this.rowData.rfpCode = firstItem.rfpCode || this.rowData.rfpCode;
                this.rowData.negotiationCode = firstItem.negotiationCode || this.rowData.negotiationCode;
                this.rowData.companyBranchName = firstItem.companyBranchName || this.rowData.companyBranchName;
                this.rowData.currency_code = firstItem.currency_code || this.rowData.currency_code || 'INR';
                this.rowData.rfpId = firstItem.rfpId || this.rowData.rfpId;
                this.rowData.vendorName = firstItem.vendorName || this.rowData.vendorName;

                // ✅ Timer ke liye date/time set karo (API se nahi aa raha toh default)
                if (!this.rowData.negotiationEndDate) {
                  // 7 din baad ki date set karo (example)
                  const futureDate = new Date();
                  futureDate.setDate(futureDate.getDate() + 7);
                  this.rowData.negotiationEndDate = futureDate.toISOString().split('T')[0];
                  this.rowData.negotiationEndTime = '18:00:00';
                }

                // ✅ dt aur endTime set karo
                this.dt = this.rowData.negotiationEndDate;
                this.endTime = this.rowData.negotiationEndTime;
                this.negoStartTime = this.rowData.negotiationStartTime || '10:00:00';

                console.log('✅ Updated rowData for display:', {
                  rfpCode: this.rowData.rfpCode,
                  negotiationCode: this.rowData.negotiationCode,
                  companyBranchName: this.rowData.companyBranchName,
                  negotiationEndDate: this.rowData.negotiationEndDate,
                  negotiationEndTime: this.rowData.negotiationEndTime
                });
              }

              this.calculateTotalAmount();

              // ✅ Timer start karo
              this.dateFormate();
              this.startTimeFormatter();
              this.startCountdown();

              this.toastr.success('Data loaded successfully');
            } else {
              console.warn('⚠️ No data found in response');
              this.liveDetails.vendorNegotiation = [];
              this.liveDetails.negotiationTotalAmount = 0;
            }
          }
        },
        error: (err: any) => {
          this.loading = false;
          console.error('❌ Error in getVendorHistory:', err);
          this.toastr.error(err.error?.message || 'Failed to fetch vendor history');
        }
      });
  }

  getYourQuote() {
    if (!this.rowData?.negotiation_id) {
      console.warn('⚠️ negotiation_id is undefined for getYourQuote');
      return;
    }

    console.log('📤 Calling getYourQuote with:', {
      negotiation_id: this.rowData.negotiation_id,
      vendorId: this.vendorId
    });

    this.loading = true;
    this.vendorNegoService.getYourQuote(this.rowData.negotiation_id, this.vendorId)
      .subscribe({
        next: (res: any) => {
          this.loading = false;
          console.log('✅ getYourQuote Response:', res);

          if (res && res.body && res.body.data) {
            this.yourQuote = res.body.data;
            console.log('✅ YourQuote data:', this.yourQuote);
          }
        },
        error: (err: any) => {
          this.loading = false;
          console.error('❌ Error in getYourQuote:', err);
        }
      });
  }

  calculateItemSum(item: any) {
    if (!item) return;
    let sum = (item.quantity || 0) * (item.itemPrice || 0);
    let sumCGST = sum * ((item.CGST || 0) / 100);
    let sumSGST = sum * ((item.SGST || 0) / 100);
    let sumIGST = sum * ((item.IGST || 0) / 100);
    let totalItemSum = sum + sumCGST + sumSGST + sumIGST + (item.Additional_charges || 0);
    item.priceIncludingCharges = parseFloat(totalItemSum.toFixed(2));
    this.calculateTotalAmount();
  }

  calculateTotalAmount() {
    if (!this.liveDetails || !this.liveDetails.vendorNegotiation) return;
    let totalAmount = 0;
    for (let item of this.liveDetails.vendorNegotiation) {
      item.priceIncludingCharges = item.priceIncludingCharges || 0;
      totalAmount += item.priceIncludingCharges;
    }
    this.liveDetails.negotiationTotalAmount = parseFloat(totalAmount.toFixed(2));
  }

  onCGSTChange(item: any) {
    if (item.CGST > 0) {
      item.IGST = 0;
    }
    this.calculateItemSum(item);
  }

  onSGSTChange(item: any) {
    if (item.SGST > 0) {
      item.IGST = 0;
    }
    this.calculateItemSum(item);
  }

  onIGSTChange(item: any) {
    if (item.IGST > 0) {
      item.CGST = 0;
      item.SGST = 0;
    }
    this.calculateItemSum(item);
  }

  submit() {
    if (this.isSubmitDisabled) {
      this.toastr.warning('Negotiation has ended. You cannot submit now.');
      return;
    }

    this.loading = true;
    this.isSubmitDisabled = true;
    this.vendorNegoService.createVendorNegotiation(this.liveDetails)
      .subscribe({
        next: (res: any) => {
          this.loading = false;
          if (res && res.body) {
            this.toastr.success(res.body.message || 'Quote submitted successfully!');
            location.reload();
          }
        },
        error: (err: any) => {
          this.loading = false;
          this.isSubmitDisabled = false;
          this.toastr.error(err.error?.message || 'Failed to submit quote');
        }
      });
  }

  itemDetails(item: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.height = 'auto';
    dialogConfig.width = '60%';
    dialogConfig.maxWidth = '1200px';
    dialogConfig.data = {
      itemdata: item,
      currency_code: this.rowData?.currency_code
    };
    this._matDialog.open(ItemDetailsComponent, dialogConfig);
  }
}